(function (angular) {
    'use strict';

    angular.module('app.support', []);
})(angular);
